/* eslint-disable arrow-body-style */
import http from '@/utils/http';

export const getGlobalViewPageDataWhenOther: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/globalView/market/genre',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getGlobalViewTabletDataWhenMobile: (payload: any, config?: any) => Promise<any> = (payload, config) => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/globalView/market/mobile_genre',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getGlobalViewMarketDataByMobile = () => {
  return http({
    url: '/api/v1/intelligence_pc/globalView/market/coreMarket',
    method: 'post',
    rawData: true,
  }) as Promise<any>;
};

export const getGlobalViewRegionDataWhenOther = () => {
  return http({
    url: '/api/v1/intelligence_pc/globalView/market/genre/filter',
    method: 'post',
    rawData: true,
  }) as Promise<any>;
};

export const getGlobalViewChartsDataWhenMobile: (payload: any, config?: any) => Promise<any> = (payload, config) => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/globalView/market/mobile_genre_charts',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const downloadGlobalViewData: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/globalView/market/genre/downloads_excel',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getGenreWhenMobile: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/globalView/market/filterGenre',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const deleteGlobalViewSearchRecord: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/delPerGenreMarketSeachRecord',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getMarketSizeDateList: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: 'api/v1/intelligence_pc/globalView/marketSize/date_list',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

export const getGlobalSizeRevenueDatas: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: 'api/v1/intelligence_pc/globalView/marketSize/revenue/summary',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

export const getGlobalSizePlayersDatas: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: 'api/v1/intelligence_pc/globalView/marketSize/players/summary',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}